"use client";

import { useEffect, useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const STORAGE_KEY = "selectedMicrophoneDeviceId";

export default function MicrophoneSelector({
  onMicrophoneSelect,
  selectedDeviceId,
}) {
  const [devices, setDevices] = useState([]);

  useEffect(() => {
    const getDevices = async () => {
      try {
        // Enumerate devices without forcing mic permission to avoid auto mic activation
        const deviceList = await navigator.mediaDevices.enumerateDevices();
        const audioInputs = deviceList.filter(
          (device) => device.kind === "audioinput"
        );
        setDevices(audioInputs);

        // Try to load saved device from localStorage
        const savedDeviceId = localStorage.getItem(STORAGE_KEY);

        // Check if saved device is still available
        const savedDeviceExists =
          savedDeviceId &&
          audioInputs.some((device) => device.deviceId === savedDeviceId);

        if (!selectedDeviceId && audioInputs.length > 0) {
          // Use saved device if it exists, otherwise use first device
          const deviceToSelect = savedDeviceExists
            ? savedDeviceId
            : audioInputs[0].deviceId;
          onMicrophoneSelect(deviceToSelect);
        }
      } catch (error) {
        console.error("Error enumerating devices:", error);
      }
    };

    getDevices();
  }, []);

  const handleMicrophoneChange = (deviceId) => {
    // Save to localStorage
    localStorage.setItem(STORAGE_KEY, deviceId);
    // Notify parent component
    onMicrophoneSelect(deviceId);
  };

  if (devices.length <= 1) {
    // Don't show selector if there's only one microphone
    return null;
  }

  return (
    <Select
      value={selectedDeviceId || devices[0]?.deviceId}
      onValueChange={handleMicrophoneChange}
    >
      <SelectTrigger className="w-auto max-w-[150px] text-xs h-8">
        <SelectValue placeholder="Choose a microphone" />
      </SelectTrigger>
      <SelectContent>
        {devices.map((device) => (
          <SelectItem key={device.deviceId} value={device.deviceId}>
            {device.label || `Microphone ${device.deviceId.slice(0, 8)}`}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
